module.exports = "pegasus_template/assets/blocks/column-9-theme5.png";